<template>
    <section id="marketing_content">

        <div class="container">

            <div class="row" id="first_row">

                <!-- In Small Screen -->
                <nav aria-label="breadcrumb" class="mt-4 d-block d-lg-none">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'marketing' }" class="text-reset">التسويق
                                والفعاليات</router-link>
                        </li>
                    </ol>
                </nav>

                <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                    <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                        <nav aria-label="breadcrumb" class="d-none d-lg-block">
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <router-link :to="{ name: 'marketing' }" class="text-reset">التسويق
                                        والفعاليات</router-link>
                                </li>
                            </ol>
                        </nav>

                        <p>تسويق وتنظيم الفعاليات والمؤتمرات وتقديم الدعم اللوجستي وبناء الشراكات الاستراتيجية بالتكامل مع
                            منظومة الجهات ذات العلاقة.</p>

                        <h5 class="mt-3">خبراء في خدمات التسويق عبر وسائل التواصل الاجتماعي للترويج للفعاليات</h5>

                        <p>تلعب وسائل التواصل الاجتماعي دورًا مهمًا في تسويق الأحداث مثل المؤتمرات، والمعارض، والحفلات،
                            وإطلاق المنتجات وغيرها من الفعاليات والأنشطة؛ حيث أن منصات وسائل التواصل الاجتماعي هي المكان
                            الأمثل للتسويق لمثل هذه الأحداث باعتبار أن الأفراد يطلعون دائمًا على ما يحدث وما سيحدث من خلال
                            الإنترنت.
                            تقدّم منصات وسائل التواصل الاجتماعي دعمًا للحدث في مراحله الثلاث سواء أكانت مرحلة التوعية ما قبل
                            الحدث، أو الفعاليات والأنشطة خلال الحدث، أو التسويق ما بعد الحدث، كما تعد استراتيجية التخطيط
                            الجيدة للحدث عبر قنوات التواصل الاجتماعي عنصر نجاحه أو حتى تفوقه وتفاعل الحضور معه ومن ثم وصوله
                            إلى قاعدة جماهيرية أوسع في المستقبل.</p>

                    </div>

                </div>

                <div
                    class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                    <div class="col_two_content">
                        <div class="img_wrapper">
                            <img src="@/assets/images/services/marketing_img.webp" alt="">
                        </div>
                    </div>

                </div>

            </div>

            <div class="row" id="second_row">

                <h5 class="mt-3 mb-0">مراحل التسويق عبر وسائل التواصل الإجتماعي</h5>

                <div class="col-12 col-lg-6 mt-3">

                    <div class="col_three_content w-100 h-100 p-3">

                        <ul class="mb-1">
                            <li>التسويق ما قبل الحدث</li>
                        </ul>

                        <p>تساعدك مرحلة التسويق ما قبل الحدث على خلق شغف ورغبة لدى الناس للحضور؛ حيث أنه يُمكن للمسوقين
                            اللعب على وتر الترقب خشية تفويت الحدث.</p>

                    </div>

                </div>

                <div class="col-12 col-lg-6 mt-3">

                    <div class="col_three_content w-100 h-100 p-3">

                        <ul class="mb-1">
                            <li>التسويق عبر وسائل التواصل الاجتماعي أثناء الحدث</li>
                        </ul>

                        <p>تعدّ تغطية الحدث أمرًا مهمًا باعتبار أن الجماهير والمشاركين سيقومون بالطبع بمشاركة تجاربهم خلاله
                            مما يقود لإنشاء محتوى رائع. مشاركة الحدث والتفاعل مع الجماهير خطوة ممتعة وضرورية لنجاحه.</p>

                    </div>

                </div>

                <div class="col-12 col-lg-6 mt-3 mb-3">

                    <div class="col_three_content w-100 h-100 p-3">

                        <ul class="mb-1">
                            <li>التغطية ما بعد الحدث</li>
                        </ul>

                        <p>يساعد نشر بعض مقاطع تغطية الحدث على تذكير الناس بأفضل أجزائه؛ كما تُمكّن هذه الخطوة الأشخاص الذين
                            لم يتمكنوا من الحضور، الحصول على لمحة سريعة عن أنواع الأحداث التي تُقيمها شركتك.</p>

                    </div>

                </div>

            </div>



        </div>

    </section>
</template>

<script>
export default {
    name: 'Marketing',
}
</script>

<style lang="scss" scoped>
#marketing_content {

    min-height: 100vh;

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        #first_row {

            nav {
                .breadcrumb {

                    li:first-of-type {
                        font-size: 16px;
                        line-height: 180%;
                        background: $Linear-Blue;
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    li:nth-of-type(2n) {
                        font-family: 'FFShamelFamily-Bold';
                        font-size: 18px;
                        line-height: 180%;
                        color: $Green;
                    }

                }

                .breadcrumb-item::before {
                    float: right;
                    margin-left: 8px;
                    background: $Linear-Blue;
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            .col_one_content {

                p {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;

                    @include breakpoints(large) {
                        font-size: 13px;
                    }

                    @include breakpoints(x-Large) {
                        font-size: 14px;
                    }
                }

                h5 {
                    font-family: 'FFShamelFamily-Bold';
                    font-size: 16px;
                    line-height: 156%;
                    color: $Green;

                    @include breakpoints(large) {
                        font-size: 14px;
                    }

                    @include breakpoints(x-Large) {
                        font-size: 14px;
                    }
                }

            }

            // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
            .col_two_content {

                position: relative;

                width: 636px;
                height: 426px;

                @include breakpoints(x-small) {
                    width: 351px;
                    height: 235px;
                }

                @include breakpoints(small) {
                    width: 516px;
                    height: 345px;
                }

                @include breakpoints(medium) {
                    width: 696px;
                    height: 466px;
                }

                @include breakpoints(large) {
                    width: 456px;
                    height: 305px;
                }

                @include breakpoints(x-Large) {
                    width: 546px;
                    height: 366px;
                }

                background: $Green;
                box-sizing: border-box;

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                .img_wrapper {

                    position: absolute;
                    top: 1px;
                    left: 1px;

                    width: 634px;
                    height: 424px;

                    @include breakpoints(x-small) {
                        width: 349px;
                        height: 233px;
                    }

                    @include breakpoints(small) {
                        width: 514px;
                        height: 343px;
                    }

                    @include breakpoints(medium) {
                        width: 694px;
                        height: 464px;
                    }

                    @include breakpoints(large) {
                        width: 454px;
                        height: 303px;
                    }

                    @include breakpoints(x-Large) {
                        width: 544px;
                        height: 364px;
                    }

                    // https://www.cssportal.com/css-clip-path-generator/
                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                    // border: solid 2px $Green;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                    }

                    img:hover {
                        opacity: 1;
                        -webkit-transition: opacity 0.5s linear 0.2s;
                        -moz-transition: opacity 0.5s linear 0.2s;
                        transition: opacity 0.5s linear 0.2s;
                    }

                }

            }

        }

        #second_row {

            h5 {

                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Yellow;
            }

            .col_three_content {

                background: $Dark-Green;

                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);

                ul {
                    font-family: 'FFShamelFamily-Bold';
                    color: $Green;
                    font-size: 14px;
                    line-height: 156%;
                    padding-right: 15px;
                }

                p {
                    color: $White;
                    font-size: 13px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;

                    @include breakpoints(x-small) {
                        font-size: 14px;
                    }

                    @include breakpoints(small) {
                        font-size: 14px;
                    }

                    @include breakpoints(medium) {
                        font-size: 14px;
                    }
        
                }

            }

        }

    }

}
</style>